import { ReactNode } from 'react';

import fs from '@/components/atoms/Fieldset';

type Props = { title: string; children: ReactNode };

export const SectionLayout = ({ title, children }: Props) => (
  <div className="flex flex-col gap-3">
    <fs.Title variant="primary">{title}</fs.Title>
    {children}
  </div>
);
